export default "__VITE_ASSET__DDri90Gs__"